import styled from '@emotion/styled';

/**
 * Stats
 */
export const StatsContainer = styled.div<{ small: boolean; isInFuture?: boolean }>`
  position: relative;
  display: inline-block;
  width: auto;
  font-size: ${(props) => (props.small === true ? (props) => props.theme.fontSizes.tiny : (props) => props.theme.fontSizes.small)}px;
  font-weight: ${(props) => (props.small === true ? (props) => props.theme.weights.regular : (props) => props.theme.weights.bold)};
  opacity: ${(props) => (props.isInFuture === true ? 0.5 : 1)};
`;
